import React, {useEffect, useState} from "react";
import './App.css';
import {BrowserRouter, useLocation} from "react-router-dom";
import {Route, Routes} from "react-router";
import Loading from "./components/Loading/Loading";
import axios from "axios";
import RecapViewerPage from "./pages/pviPages/RecapViewerPage";
import PrivateRoute from "./components/PrivateRoute";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import InterventionsArchives from "./pages/pviPages/InterventionsArchive";
import InterventionsAVenir from "./pages/pviPages/InterventionsAVenir";
import RecapDepannage from "./pages/DepannagePages/RecapDepannage";
import BreadContext from "./context/BreadContext";

const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const HomePage = React.lazy(() => import('./pages/HomePage'));
const PVIPage = React.lazy(() => import('./pages/pviPages/PVIPage'));
const Depannage = React.lazy(() => import('./pages/DepannagePages/Depannage'));
const Audit = React.lazy(() => import('./pages/Audit/Audit'));
const RecapitulatifIntervention = React.lazy(() => import('./pages/pviPages/RecapitulatifIntervention'));
const ConstructionPage = React.lazy(() => import('./pages/ConstructionPage'));
axios.defaults.withCredentials = true;

function App() {
    const [bread, setBread] = useState([])
    return <>
        <BreadContext.Provider value={{bread, setBread}}>
            <BrowserRouter>
                <Routes>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <LoginPage/>
                        </React.Suspense>
                    } path={"/"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <HomePage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/home"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <InterventionsAVenir/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/interavenir"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <InterventionsArchives/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/interpassee"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                {/* <Depannage /> */}
                                <ConstructionPage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/depannage"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                {/* <Audit /> */}
                                <ConstructionPage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/audit"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <PVIPage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/pvi/:id/:state"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <RecapitulatifIntervention/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/recap/:id"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <RecapViewerPage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/viewerRecap/:id"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <RecapDepannage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/depannage/:id"}/>
                    <Route element={
                        <React.Suspense fallback={<><Loading/></>}>
                            <PrivateRoute>
                                <RecapDepannage/>
                            </PrivateRoute>
                        </React.Suspense>
                    } path={"/new/depannage"}/>
                </Routes>
            </BrowserRouter>
        </BreadContext.Provider>
        <ToastContainer position={"bottom-right"} theme={"colored"}/>
    </>;
}

export default App;
